import styled from "@emotion/styled";
import { color } from "metabase/lib/colors";

export const ModalTrigger = styled.a`
  &:hover {
    color: ${color("brand")};
  }
`;
